import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import { useParams } from 'react-router-dom'
import { useGetVideoByIdQuery, useGetVideosQuery } from "../../features/video/videoApi"
import CourseItem from '../../components/CourseItem'
import Modal from '../../components/Modal'
import Quiz from './Quiz'
import ModalHeader from '../../components/ModalHeader'
import SubmitAssignment from '../../components/SubmitAssignment'
import { useGetAssignmentByStudentIdQuery } from '../../features/assignment/assignment.Api'
import { useSelector } from 'react-redux'

export default function CoursePlayer() {
  const { videoId } = useParams()
  const { user } = useSelector(state => state.auth)
  const { id: studentId } = user || {}
  const { isSuccess: isSuccessFetchVideos, data: videos } = useGetVideosQuery()
  const { isSuccess: isSuccessFetchVideo, data: video } = useGetVideoByIdQuery(videoId)
  const { isSuccess: isSuccessFetchStudentAssignment, data: studentAssignment } = useGetAssignmentByStudentIdQuery(studentId)

  const [videoInfo, setVideoInfo] = useState({})
  const [openModal, setOpenModal] = useState(false)
  const [openAssignmentModal, setOpenAssignmentModal] = useState(false)
  const [checkAlreadySubmitAssignment, setCheckAlreadySubmitAssignment] = useState(true)

  const { title, url, description } = videoInfo

  useEffect(() => {
    if (isSuccessFetchVideo && video?.length > 0) {
      setVideoInfo(video[0])
    }
  }, [isSuccessFetchVideo, video])


  useEffect(() => {
    if (isSuccessFetchStudentAssignment && studentAssignment?.length === 0) {
      setCheckAlreadySubmitAssignment(false)
    }
  }, [isSuccessFetchStudentAssignment, studentAssignment])

  console.log("checkAlreadySubmitAssignment", checkAlreadySubmitAssignment)
  console.log(studentAssignment?.length === 0)

  return (
    <Layout>
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="grid grid-cols-3 gap-2 lg:gap-8">
            <div className="col-span-full w-full space-y-8 lg:col-span-2">
              <iframe width="100%" className="aspect-video" src={url}
                title={title}
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe>

              <div>
                <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                  {title}
                </h1>
                <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
                  Uploaded on 23 February
                  2020</h2>

                <div className="flex gap-4">
                  <button  onClick={() => setOpenAssignmentModal(true)}
                    className="disabled:cursor-not-allowed px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">
                    এসাইনমেন্ট
                  </button>

                  <button onClick={() => setOpenModal(true)}
                    className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">কুইজে
                    অংশগ্রহণ
                    করুন</button>
                </div>
                <p className="mt-4 text-sm text-slate-400 leading-6">
                  {description}
                </p>


              </div>
            </div>
            <div
              className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
              {isSuccessFetchVideos && videos.length > 0 && videos.map(video => <CourseItem key={video.id} video={video} />)}
            </div>
          </div>
        </div>

      </section>
      {openAssignmentModal && <Modal>
        <ModalHeader title="Submit Assignment" closeModal={() => setOpenAssignmentModal(false)} />
        <SubmitAssignment closeModal={() => setOpenAssignmentModal(false)} />
      </Modal>}
      {openModal && <Modal>
        <ModalHeader title="Quiz" closeModal={() => setOpenModal(false)} />
        <Quiz />
      </Modal>}
    </Layout>
  )
}
